import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers/constants
import * as GC from '../../constants';
// feature roles
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  roles: [],
  settings: null,
  currentUserSettings: null,
  [GC.UI_FIELD_REFERENCES]: [],
  availableByUserTypeRoleList: null,
};

const setInitialState = () => initialState;

const setCurrentUserProfilePhotoUrl = (state, url) =>
  P.$set('currentUserSettings.profilePhotoUrl', url, state);

const getCurrentUserSettingsSuccess = (state, data) => (
  P.$set('currentUserSettings', data, state)
);

const getCurrentUserSettingsFail = (state) => (
  P.$set('currentUserSettings', null, state)
);

const getUserSettingsSuccess = (state, data) => (
  P.$set('settings', data, state)
);

const getUserSettingsFail = (state) => (
  P.$set('settings', null, state)
);

const getUserReferencesSuccess = (state, data) => (
  P.$set(GC.UI_FIELD_REFERENCES, data, state)
);

const getUserReferencesFail = (state) => (
  P.$set(GC.UI_FIELD_REFERENCES, [], state)
);

const createUserReferenceSuccess = (state, data) => (
  P.$add(GC.UI_FIELD_REFERENCES, { [data.guid]: data }, state)
);

const updateUserReferenceSuccess = (state, data) => (
  P.$merge(`${GC.UI_FIELD_REFERENCES}.${data.guid}`, data, state)
);

const deleteUserReferenceSuccess = (state, guid) => (
  P.$drop(`${GC.UI_FIELD_REFERENCES}.${guid}`, state)
);

const getUserProfileRolesSuccess = (state, data) => (
  P.$set('roles', data, state)
);

const getUserProfileRolesFail = (state) => (
  P.$set('roles', [], state)
);

const changeUserSuspendedStatusSuccess = (state) => (
  P.$toggle('settings.active', state)
);

const changeUserSsoLoginRequiredStatusSuccess = (state) => (
  P.$toggle('settings.ssoLoginRequired', state)
);

const pinBranchSuccess = (state, data = []) => (
  P.$set(`currentUserSettings.${GC.PINNED_BRANCHES_GUIDS}`, data, state)
);

const changePinnedSuccess = (state, data = []) => (
  P.$set('currentUserSettings.pinnedMenuItems', data, state)
);

const getAvailableByUserTypeRoleListSuccess = (state, data) => (
  P.$set('availableByUserTypeRoleList', data, state)
);

export default createReducer({
  [A.setInitialState]: setInitialState,
  [A.pinBranchSuccess]: pinBranchSuccess,
  [A.getUserSettingsFail]: getUserSettingsFail,
  [A.getUserReferencesFail]: getUserReferencesFail,
  [A.getUserSettingsSuccess]: getUserSettingsSuccess,
  [A.getUserProfileRolesFail]: getUserProfileRolesFail,
  [A.changePinnedMenuItemsSuccess]: changePinnedSuccess,
  [A.getUserReferencesSuccess]: getUserReferencesSuccess,
  [A.getCurrentUserSettingsFail]: getCurrentUserSettingsFail,
  [A.createUserReferenceSuccess]: createUserReferenceSuccess,
  [A.updateUserReferenceSuccess]: updateUserReferenceSuccess,
  [A.deleteUserReferenceSuccess]: deleteUserReferenceSuccess,
  [A.getUserProfileRolesSuccess]: getUserProfileRolesSuccess,
  [A.setCurrentUserProfilePhotoUrl]: setCurrentUserProfilePhotoUrl,
  [A.getCurrentUserSettingsSuccess]: getCurrentUserSettingsSuccess,
  [A.changeUserSuspendedStatusSuccess]: changeUserSuspendedStatusSuccess,
  [A.getAvailableByUserTypeRoleListSuccess]: getAvailableByUserTypeRoleListSuccess,
  [A.changeUserSsoLoginRequiredStatusSuccess]: changeUserSsoLoginRequiredStatusSuccess,
}, initialState);
